import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from "moment";
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper, FlatFeeModalWrapper } from '.././PTPlusStyled'
import { Table } from 'reactstrap';
import { deleteFlatFee, adminFlatFeeUpdateApi } from 'redux/actions/adminPtPlus/index';
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import { Modal, ModalBody } from 'reactstrap';
import FlatFeeAdditionModal from './FlatFeeAdditionModal'
import YesNoModal from "web/components/YesNoModal";
import AlertModal from 'web/components/AlertModal';
import { Form, Formik } from 'formik';
import CheckboxInput from "web/components/form-elements/CheckboxInput";


function FlatFee(pageProps) {
  const { fetchLocationsListFunction, locationsList, flatFeeDataList, adminLogout, setFlatFeeAddModal, flatFeeAddModal } = pageProps
  const dispatch = useDispatch();
  const [flatFeeDisplayList, setFlatFeeDisplayList] = useState([flatFeeDataList])
  const [isActive, setIsActive] = useState(true)
  const [accordionOpen, setAccordionOpen] = useState(false)
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [editData, seteditData] = useState([])
  const [selectedId, setSelectedId] = useState(false);
  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
  const [yesNoModalContent, setYesNoModalContent] = useState("");

  let headerArr = [
    { title: 'Location Name', },
    { title: 'Pallet Details', },
    { title: 'Flat Fee', },
    { title: 'Start Date', },
    { title: 'End Date', },
    { title: 'Comments', },
    { title: 'Action', },
  ];

  useEffect(() => {
    let finalDataList = flatFeeDataList;
    if (isActive) {
      const today = moment().format("YYYY-MM-DD");
      finalDataList = flatFeeDataList.filter(item => {
        const startDate = moment(item.rateStartDate).format("YYYY-MM-DD");
        const expirationDate = moment(item.rateExpirationDate).format("YYYY-MM-DD");
        return moment(startDate).isSameOrBefore(today) && moment(expirationDate).isSameOrAfter(today);
      });
    }
    setFlatFeeDisplayList(finalDataList);
  }, [isActive, flatFeeDataList]);

  const deactivateFlatFeeFunction = async (value) => {
    let response = ''
    const token = localStorage.getItem('token')
    let data = {
      locationId: value.locationId,
      locationName: value.locationName,
      fee: value.fee,
      active: !value.active,
      currency: value.currency,
      rateStartDate: moment(value.rateStartDate).format('YYYY-MM-DD HH:mm'),
      rateExpirationDate: moment(value.rateExpirationDate).format('YYYY-MM-DD HH:mm'),
      palletDetails: value.palletDetails
    }
    let message = value.active ? 'Flat fee deactivated successfully.' : 'Flat fee activated successfully.'
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      response = await dispatch(adminFlatFeeUpdateApi(value?.flatFeeId, data, token))
      if (response?.success) {
        // setAlertModalContent("The flat fee can't be deactivated as the order is associated with the same.")
        setAlertModalContent(message)
        setAlertModal(!alertModal)
        fetchLocationsListFunction()
      } else {
        if (response?.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }

  const deleteApi = async (val) => {
    const token = localStorage.getItem('token')
    val.active = false
    let response = await dispatch(deleteFlatFee(val.locationId, val.flatFeeId, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response?.success) {
        setAlertModalContent("Flat fee deleted successfully.")
        setAlertModal(!alertModal)
        fetchLocationsListFunction()
      } else {
        if (response?.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
    }
  }

  const orderType = (items) => {
    let material = items?.palletDetails?.material
    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join(", ")
    } else {
      condition = items?.palletDetails?.condition
    }

    let palletType;
    let moisture = "";
    let size = "";
    let grade = "";
    let isHeatTreated = '';
    let LWH
    let truckPreference = items?.equipment
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height

      if (condition) {
        return material + ", " + LWH + "-" + condition + ", " + truckPreference
      } else {
        return material + ", " + LWH + ", " + truckPreference
      }

    } else {
      palletType = ", " + items?.palletDetails?.palletType

      if (items?.palletDetails?.moisture) moisture = ", " + items?.palletDetails?.moisture
      if (items?.palletDetails?.size) size = items?.palletDetails?.size
      if (items?.palletDetails?.grade) grade = ", " + items?.palletDetails?.grade
      if (items?.palletDetails?.heatTreared) isHeatTreated = ', HT'

      let hardOrSoftWood
      if (items.palletDetails?.newConditionType === 'HARDWOOD') hardOrSoftWood = '(HW)'
      else if (items.palletDetails?.newConditionType === 'SOFTWOOD') hardOrSoftWood = '(SW)'

      if (hardOrSoftWood) return size + grade + moisture + isHeatTreated + palletType + "-" + condition + hardOrSoftWood + ", " + truckPreference
      else return size + grade + moisture + isHeatTreated + palletType + "-" + condition + ", " + truckPreference
    }

  }

  const editDataFunction = (val) => {
    seteditData(val)
    setFlatFeeAddModal(true)
    if (val?.palletDetails?.palletType === 'EUROPALLET') {
      pageProps.setFieldValue("palletType", "euroPallet")
    } else {
      pageProps.setFieldValue("palletType", val?.palletDetails?.palletType.toLowerCase() || "")
    }
    let isLtl = val?.equipment === 'LTL' ? true : false
    pageProps.setFieldValue('addLocationInput', val?.locationId || '')
    pageProps.setFieldValue('flatFeeValue', val?.fee || '')
    pageProps.setFieldValue('rateStartDate', val?.rateStartDate)
    pageProps.setFieldValue('rateExpDate', val.rateExpirationDate)
    pageProps.setFieldValue("material", val?.palletDetails?.material?.toUpperCase() || "WOOD")
    pageProps.setFieldValue("condition0", val?.palletDetails?.condition[0] === 'RECYCLED' || "")
    pageProps.setFieldValue("condition1", val?.palletDetails?.condition[0] === 'NEW' || "")
    pageProps.setFieldValue("condition2", val?.palletDetails?.condition[0] === 'COMBO' || "")
    pageProps.setFieldValue("condition3", val?.palletDetails?.condition[0] === 'CORES' || "")
    pageProps.setFieldValue("moisture", val?.palletDetails?.moisture?.toUpperCase() || "")
    pageProps.setFieldValue("size", val?.palletDetails?.size || "")
    pageProps.setFieldValue("grade", val?.palletDetails?.grade || "")
    pageProps.setFieldValue("length", val?.palletDetails?.length || "")
    pageProps.setFieldValue("width", val?.palletDetails?.width || "")
    pageProps.setFieldValue("height", val?.palletDetails?.height || "")
    pageProps.setFieldValue("comment", val?.comment || "")
    pageProps.setFieldValue("isLtl", isLtl)
    pageProps.setFieldValue("flatFeeSpecEdit", true)
    if (val?.palletDetails?.newConditionType) {
      if (val?.palletDetails?.newConditionType === 'HARDWOOD') pageProps.setFieldValue("hardOrSoftWood", 'New - Hardwood')
      else if (val?.palletDetails?.newConditionType === 'SOFTWOOD') pageProps.setFieldValue("hardOrSoftWood", 'New - Softwood')
    }
  }

  const seteditDataFunction = () => {
    pageProps.setFieldValue("palletType", "")
    pageProps.setFieldValue('addLocationInput', '')
    pageProps.setFieldValue('flatFeeValue', '')
    pageProps.setFieldValue("material", "WOOD")
    pageProps.setFieldValue("condition0", "")
    pageProps.setFieldValue("condition1", "")
    pageProps.setFieldValue("condition2", "")
    pageProps.setFieldValue("condition3", "")
    pageProps.setFieldValue("moisture", "")
    pageProps.setFieldValue("size", "")
    pageProps.setFieldValue("grade", "")
    pageProps.setFieldValue("length", "")
    pageProps.setFieldValue("width", "")
    pageProps.setFieldValue("height", "")
    pageProps.setFieldValue("flatFeeSpecEdit", false)
  }

  return (
    <>
      <Container>
        <AccordionHeader>
          <h6 onClick={() => {
            if (accordionOpen) setAccordionOpen(false)
            else setAccordionOpen(true)
          }}>Flat Fee</h6>
          {accordionOpen ?
            <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
            : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
          }
        </AccordionHeader>
        {accordionOpen &&
          <AccordionBody>
            <InputFieldsWrapper>
              <div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', gap: '20px' }}>
                  <div className='flat-fee-checkbox-styled'>
                    <Formik initialValues={{ isActive: false }}>
                      {() => (
                        <Form>
                          <CheckboxInput
                            name="activeFlatFee"
                            label="Active Flat Fees"
                            checked={isActive}
                            handleSelect={(name, label, flag) => {
                              setIsActive(flag)
                            }}
                          />
                        </Form>
                      )}
                    </Formik>
                  </div>
                  <button className='green-button' onClick={() => fetchLocationsListFunction('openFlatFeeModal')}>
                    <AddPlusIcon />Add Flat Fee</button>
                </div>
                <Table responsive>
                  <thead>
                    <tr>
                      {headerArr.map((items, index) => (
                        <th key={index}>
                          {items.title}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {flatFeeDisplayList && flatFeeDisplayList.length > 0 && flatFeeDisplayList.map((val, index) => {
                      return (
                        <tr key={index} className='flat-fee-table-data'>
                          <td>{val.locationName ? `${val.locationName} - ${val?.address?.city}, ${val?.address?.state}` : val.locationId}</td>
                          <td>{orderType(val)}</td>
                          <td>$ {val?.fee?.toFixed(2)}</td>
                          <td>{val.rateStartDate}</td>
                          <td>{val.rateExpirationDate}</td>
                          {/* <td>{val?.comment}</td> */}
                          <td title={val?.comment} style={{ minWidth: '100px', 'cursor': 'pointer' }}>
                            {val?.comment?.substring(0, 15)}
                            {val?.comment?.length > 15 && <span>...</span>}
                          </td>
                          <td>
                            {
                              <button className='green-button' style={{ width: '85px', height: '24px' }}
                                onClick={() => {
                                  pageProps.setFieldValue("isHeatTreared", val?.palletDetails?.heatTreared || "")
                                  editDataFunction(val)
                                }}>Edit</button>
                            }
                            {
                              !val.ordersAssociated &&
                              <button className='green-button' style={{ width: '85px', height: '24px', marginLeft: '10px' }}
                                onClick={() => {
                                  setYesNoModalContent("Do you want to delete the flat fee?")
                                  yesNoToggleModal()
                                  setSelectedId(val)
                                }}>Delete</button>
                            }
                            {/* <button className='green-button' style={{ width: '85px', height: '24px' }}
                                onClick={() => deactivateFlatFeeFunction(val)
                                }>{val.active ? 'Deactivate' : 'Activate'}</button> */}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            </InputFieldsWrapper>
          </AccordionBody>
        }
      </Container>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
      />

      <YesNoModal
        isOpen={yesNomodal}
        toggle={yesNoToggleModal}
        title=""
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            deleteApi(selectedId)
            setSelectedId("")
          }
        }}
        content={yesNoModalContent}
        link="/"
      />
      <Modal isOpen={flatFeeAddModal} centered={true}>
        <FlatFeeModalWrapper>
          <ModalBody>
            <FlatFeeAdditionModal
              editDatas={editData}
              pageData={pageProps.pageData}
              formikProps={pageProps.formikProps}
              setFieldValue={pageProps.setFieldValue}
              locationsList={locationsList}
              fetchLocationsListFunction={fetchLocationsListFunction}
              toggle={() => {
                setFlatFeeAddModal(false)
                seteditDataFunction()
              }}
            />
          </ModalBody>
        </FlatFeeModalWrapper>
      </Modal>
    </>
  )
}

export default FlatFee
